import React from 'react';
import processImg1 from '../../assets/img/processImg1.png';
import processImg2 from '../../assets/img/processImg2b.png';
import radar from '../../assets/img/radar2.svg';
import {
    Button
} from 'reactstrap';
import { Link } from 'react-router-dom';

const FeaturedProcess = () => (
    <div>
        <div className={''}>
            <div className="container-fluid no-pd" style={{background:'rgb(251, 251, 251)',marginTop:'50px'}}>
                <div className="feature-1">
                    <div className="radar-right">
                        <img src={radar} alt="radar"/>
                    </div>
                <div className="container">
                    <div className="row">
                        <div className="one col-md-6 col-sm-12">
                            <div className="left">
                            <h4 className='mb-4 title text-uppercase'>
                                Big Data <br/> Analytics
                            </h4>
                            <p>
                                You can figure out variables related to the profitability of each outgoing or grounded flight, get precise stats about baggage or number of flights, flight destination, ticketing information, and other vital metrics, all geared towards aiding a more efficient decision-making process for your business or organisation; all with AviTech's big data analytics platform
                            </p>
                            <Link to="/products">
                                <Button className='mt-3'>
                                    Read More
                                </Button>
                            </Link>
                            </div>
                        </div>
                        <div className="two col-md-6 col-sm-12">
                            <div className='bg-radar'>
                                <img src={processImg1} alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>


        </div>
        <div className={'feature-2'}>
            <div className="radar-left">
                <img src={radar} alt="radar"/>
            </div>
            <div className="container">

                <div className="row">
                    <div className="col-md-6 col-sm-12">
                        <div className='img-container-alt'>
                            <img src={processImg2} alt="" width={'350'}/>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="right">
                        <h4 className='mb-5 title text-uppercase'>
                            Revenue <br/>Assurance
                        </h4>
                        <p>
                            The platform comes complete with an offering of data quality and trusted process improvement methods which are tailored for both public and private organisations and agencies in the aviation sector to solve challenges associated with leakages in revenue earned, and help clients achieve a remarkable improvement in operational efficiency and increased cash flows through transparency and seamless data capture.
                        </p>
                        <Link to="/products">
                            <Button className='mt-3'>
                                Read More
                            </Button>
                        </Link>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default FeaturedProcess;



// WEBPACK FOOTER //
// ./src/views/home/featured-process.js